<!-- <ul>
    <li pTooltip="Profile" [tooltipDisabled]="isTooltipDisabled()">
        <button pButton class="p-button-text" (click)="toggleMenu()" pTooltip="Profile" [tooltipDisabled]="isTooltipDisabled()">
            <i class="layout-menu-profile-image pi pi-user"></i>
            <span class="text-start">
                <strong>{{this.app.userInfo?.EmployeeName}}</strong>
                <br/>
                <small *ngIf="this.app.userRoles && this.app.userRoles.length > 0">{{this.app.userRoles[0].GroupName}}</small>
            </span>
        </button>
    </li>
</ul>
<ul *ngIf="menuProfileActive()" [@menu]="isHorizontal() ? 'overlay' : 'inline'">
    <li pTooltip="My Settings" [tooltipDisabled]="isTooltipDisabled()">
        <button pButton class="p-button-text" (click)="this.app.onProfileMySettingsClick()">
            <i class="pi pi-cog pi-fw"></i>
            <span>My Settings</span>
        </button>
    </li>
    <li pTooltip="Theme" [tooltipDisabled]="isTooltipDisabled()">
        <button pButton class="p-button-text" (click)="this.toggleTheme()">
            <i class="pi pi-palette pi-fw"></i>
            <span>Toggle Theme</span>
        </button>
    </li>
    <li [pTooltip]="tooltipContent" [tooltipDisabled]="isTooltipDisabled()">
        <ng-template #tooltipContent>
            <span *ngIf="this.layoutService.layoutConfig().menuMode === 'reveal'">Lock Menu</span>
            <span *ngIf="this.layoutService.layoutConfig().menuMode === 'slim'">Unlock Menu</span>
        </ng-template>
        <button pButton class="p-button-text" (click)="this.toggleMenuType()">
            <i *ngIf="this.layoutService.layoutConfig().menuMode === 'reveal'" class="pi pi-lock pi-fw"></i>
            <i *ngIf="this.layoutService.layoutConfig().menuMode === 'slim'" class="pi pi-lock-open pi-fw"></i>
            <span *ngIf="this.layoutService.layoutConfig().menuMode === 'reveal'">Lock Menu</span>
            <span *ngIf="this.layoutService.layoutConfig().menuMode === 'slim'">Unlock Menu</span>
        </button>
    </li>
    <li pTooltip="Logout" [tooltipDisabled]="isTooltipDisabled()" [uiSref]="'main'">
        <button pButton class="p-button-text p-button-error" (click)="this.app.onSignout()">
            <i class="pi pi-power-off pi-fw"></i>
            <span>Logout</span>
        </button>
    </li>
</ul> -->
<!-- <ul>
    <li pTooltip="My Settings" [tooltipDisabled]="isTooltipDisabled()">
        <button pButton class="p-button-text" (click)="settingsToggle = true">
            <i class="pi pi-cog pi-fw"></i>
        </button>
    </li>
    <li pTooltip="Profile" [tooltipDisabled]="isTooltipDisabled()">
        <button pButton class="p-button-text" (click)="profileToggle = true" pTooltip="Profile" [tooltipDisabled]="isTooltipDisabled()">
            <i class="layout-menu-profile-image pi pi-user"></i>
        </button>
    </li>
</ul> -->
<p-drawer [(visible)]="profileToggle"
          position="left"
          [transitionOptions]="'0.4s ease-in-out'"
          [style]="{'background': '#10101070', 'backdrop-filter': 'blur(15px)', 'border': '0', 'border-radius': '8px', 'min-width': '20rem', 'width': '15vw', 'height': '45vh', 'margin-left': '73px', 'margin-top': '60px'}">
    <ng-template #header>
        <div>
            <span class="text-900 pb-0 text-xl font-medium text-white">{{this.app.userInfo?.EmployeeName}}</span>
            <div>
                <small *ngIf="this.app.userRoles && this.app.userRoles.length > 0" class="text-white">{{this.app.userRoles[0].GroupName}}</small>
            </div>
        </div>
    </ng-template>

    <span class="text-start mt-3">
        <div class="grid mt-2 mx-2">
            <div class="col-12">
                <button class="w-full h-full" severity="secondary" pButton pRipple (click)="this.app.onProfileMySettingsClick(); profileToggle = false;" icon="pi pi-cog" label="My Settings"></button>
            </div>
            <div class="col-12">
                <button class="w-full h-full" severity="secondary" pButton pRipple (click)="this.app.onChangePasswordClick(null); profileToggle = false;" icon="pi pi-key" label="Change Password"></button>
            </div>
            <div class="col-12">
                <button class="w-full h-full" severity="secondary" *ngIf="this.layoutService.layoutConfig().darkTheme == false" pButton pRipple (click)="this.toggleTheme()" icon="pi pi-moon" label="Dark Mode"></button>
                <button class="w-full h-full" severity="secondary" *ngIf="this.layoutService.layoutConfig().darkTheme == true" pButton pRipple (click)="this.toggleTheme()" icon="pi pi-sun" label="Light Mode"></button>
            </div>
        </div>
    </span>

    <ng-template #footer>
        <button pButton text severity="danger" (click)="this.app.onSignout(); profileToggle = false;" class="position-fixed bottom-0 right-0 m-3">
            <i class="pi pi-power-off pi-fw"></i>
            <span>Logout</span>
        </button>
    </ng-template>
</p-drawer>
<ul>
    <li pTooltip="Profile" [tooltipDisabled]="isTooltipDisabled()">
        <button pButton pRipple text styleClass="flex justify-content-start" (click)="profileToggle = !profileToggle" pTooltip="Profile" [tooltipDisabled]="isTooltipDisabled()">
            <i class="layout-menu-profile-image pi pi-user"></i>
            <span class="layout-menuitem-text">User Profile</span>
        </button>
    </li>
</ul>
<!-- <div
    #profileBackdrop
    *ngIf="profileToggle"
    class="profile-backdrop"
    (click)="profileToggle = false;"
    style="position:fixed;top:0;left:0;width:100vw;height:100vh;z-index:9998;background:transparent;"
></div> -->
<!-- <div #profilePanel class="sidebar-menu-profile"
     [@profilePanel]="profileToggle ? 'visible' : 'hidden'">
    <span class="text-start m-4">
        <span class="block text-900 pb-0 text-xl font-medium ml-3">{{this.app.userInfo?.EmployeeName}}</span>
        <p-floatLabel variant="on" class="mt-2 mx-3">
            <p-select
                appendTo="body"
                styleClass="w-full"
                [options]="rolesSelectItem"
                (onChange)="roleChanged($event)"
            >
            </p-select>
            <label>User Role</label>
        </p-floatLabel>

        <div class="grid mt-2 mx-2">
            <div class="col-12">
                <p-floatLabel variant="on" class="mt-2">
                    <p-select
                        styleClass="w-full"
                        appendTo="body"
                        [filter]="true"
                        [options]="primaryColorSelectItem"
                        [(ngModel)]="this.selectedPrimaryColor"
                        (onChange)="primaryColorChanged($event)"
                    >
                    </p-select>
                    <label>Theme Color</label>
                </p-floatLabel>
            </div>
            <div class="col-6">
                <button class="w-full h-full" text pButton pRipple (click)="this.app.onProfileMySettingsClick()" icon="pi pi-cog" label="My Settings"></button>
            </div>
            <div class="col-6">
                <button class="w-full h-full" text *ngIf="this.layoutService.layoutConfig().darkTheme == false" pButton pRipple (click)="this.toggleTheme()" icon="pi pi-moon" label="Dark Mode"></button>
                <button class="w-full h-full" text *ngIf="this.layoutService.layoutConfig().darkTheme == true" pButton pRipple (click)="this.toggleTheme()" icon="pi pi-sun" label="Light Mode"></button>
            </div>
        </div>
    </span>
    <button pButton text severity="danger" (click)="this.app.onSignout(); profileToggle = false;" class="position-fixed bottom-0 right-0 m-3">
        <i class="pi pi-power-off pi-fw"></i>
        <span>Logout</span>
    </button>
</div> -->
